var map = {
	"./apple.png": 829,
	"./apricot.png": 85,
	"./avocado.png": 636,
	"./banana.png": 393,
	"./beetroot.png": 603,
	"./blackberry.png": 674,
	"./blueberry.png": 113,
	"./brinjal.png": 743,
	"./broccoli.png": 371,
	"./cabbage.png": 409,
	"./capsicum.png": 930,
	"./carrot.png": 503,
	"./cauliflower.png": 661,
	"./coconut.png": 986,
	"./corn.png": 79,
	"./cucumber.png": 13,
	"./dragonfruit.png": 232,
	"./gooseberry.png": 223,
	"./grapes.png": 497,
	"./jackfruit.png": 157,
	"./kiwifruit.png": 522,
	"./lady-finger.png": 63,
	"./mango.png": 170,
	"./mushroom.png": 110,
	"./orange.png": 107,
	"./papaya.png": 718,
	"./peach.png": 864,
	"./peas.png": 54,
	"./pineapple.png": 382,
	"./pomegranate.png": 27,
	"./potato.png": 617,
	"./pumpkin.png": 924,
	"./spinach.png": 772,
	"./strawberry.png": 248,
	"./sweetpotato.png": 233,
	"./tomato.png": 565,
	"./watermelon.png": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;